export const FORM_DISPLAY_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/FormCustomComponentV1_0_0.json' as const;
export const FORM_DISPLAY_COMPONENT_TYPE = 'FormDisplay' as const;
